import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const MenuIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" viewBox="0 0 23 18">
        <g data-name="Group 9056">
          <g data-name="Group 8982">
            <path
              data-name="Line 311"
              transform="translate(1 .999)"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="2px"
              d="M0 0h21"
            />
            <path
              data-name="Line 312"
              transform="translate(1 8.999)"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="2px"
              d="M0 0h21"
            />
            <path
              data-name="Line 313"
              transform="translate(1 16.999)"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="2px"
              d="M0 0h21"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
});
